module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('yd-countdown', {
    attrs: {
      "time": _vm.time,
      "format": "{%d}天{%h}时{%m}分{%s}秒后截止",
      "timetype": "second"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-414afe55","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/base/countDown/index.vue
// module id = 285
// module chunks = 0